import * as z from 'zod';
import { formatZodError } from "utils/zod-error";
import { update } from "./update";

const idSchema = z.union([z.number(), z.string()]);
const idsSchema = idSchema.array();

type RemoveParams = z.infer<typeof idsSchema> | z.infer<typeof idSchema>;

export const remove = async (ids: RemoveParams, noIntercept?: boolean) => {
  const items = Array.isArray(ids) ? ids : [ids];
  const parseResult = idsSchema.safeParse(items);
  if (!parseResult.success) throw new TypeError(`Couldn't remove from cart due to invalid params: ${formatZodError(parseResult.error)}`);
  const updateParams = {
    updates: Array.isArray(ids) ? ids.reduce((acc, id) => ({ ...acc, [id]: 0 }), {}) : { [ids]: 0 },
  };
  return update(updateParams, noIntercept);
};
